import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer id="bottom-footer">
      <div className="footer-content">
        <div className="footer-left">
          <span className="copyright">© 2025 Voxel3D. Todos los derechos reservados.</span>
        </div>
        <div className="footer-right">
          <a href="#" className="footer-link" id="cookiesLink">Política de Cookies</a>
          <a 
            href="https://grupocfi.es/privacidad/voxel3d/" 
            className="footer-link" 
            id="privacyLink"
            target="_blank"
            rel="noopener noreferrer"
          >
            Política de Privacidad
          </a>
          <a 
            href="https://voxel3d.es/aviso-legal/" 
            className="footer-link" 
            id="legalLink"
            target="_blank"
            rel="noopener noreferrer"
          >
            Aviso Legal
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
